import React, { useEffect, useState } from 'react';
import { useTitle, useMediaQuery, useUser } from '../HooksPublic';
import { Button, Icon } from 'react-frontier';
import API from '../APIPublic';


import '../style/rewards.scss';
import { CDN_URL } from '../ConfigPublic';

const BENEFITS = [
	{
		icon: <Icon name='smile' />,
		title: 'Acumula en cada compra',
		desc: 'Por cada $10 de compra, ganas 1 Cocoin.',
	},
	{
		icon: <Icon name='gift' />,
		title: 'Productos sólo para miembros',
		desc: 'Ciertos productos de nuestro catálogo están disponibles únicamente para quienes forman parte del Cocoan Club Rewards. ',
	},
	{
		icon: <Icon name='heart' />,
		title: 'Sé de los primeros en probar',
		desc: 'Los miembros tienen acceso anticipado a nuevos lanzamientos, antes que nadie más',
	},
];

const LEVEL_CARDS = [
	{
		name: <div style={{ textAlign: 'center' }}><span className="font-graphik">Choco</span><br /><span className="font-homemade-apple">Plus</span></div>,
		img: `${CDN_URL}/static/rewards/N1.webp`,
		beans: 1,
		desc: 'Nivel de entrada al Cocoan Club. Desde tu primera compra ya eres parte de la comunidad, con acceso a una selección de productos pensados para ti.',
		perks: [
			'Acceso a productos para miembros.',
			'Acumula Cocoins con cada compra.',
			'Registra tus visitas.',
		],
		badge_text: '0 - Sólo regístrate',
		sub_text: 'Cocoins',
	},
	{
		name: <div style={{ textAlign: 'center' }} ><span className="font-graphik">Choco</span><br /><span className="font-homemade-apple">Master</span></div>,
		img: `${CDN_URL}/static/rewards/N2.webp`,
		beans: 2,
		desc: 'Nuestro catálogo se abre un poco más al llegar al nivel Master. Es el reconocimiento a quienes ya nos visitan de forma constante.',
		perks: [
			'Merch de bienvenida (recoger en tienda).',
			'Catálogo ampliado de productos para miembros.',
			'Mejores precios en tu catálogo.',
		],
		badge_text: '600',
		sub_text: 'Cocoins',
	},
	{
		name:	<span className="font-homemade-apple">Chocolover</span>,
		img: `${CDN_URL}/static/rewards/N3.webp`,
		beans: 3,
		desc: 'Acceso al catálogo completo, a los mejores precios y a todo lo que reservamos para quienes viven el chocolate como nosotros.',
		perks: [
			'Catálogo completo de productos para miembros.',
			'Los mejores precios del programa.',
			'Acceso anticipado a lanzamientos de nuevos productos.',
		],
		badge_text: '1,500',
		sub_text: 'Cocoins',
	}
];

var Rewards = () => {
	var { setTitle } = useTitle();
	var { user, login, token } = useUser();
	var [walletError, setWalletError] = useState<string | null>(null);
	var [loadingGoogle, setLoadingGoogle] = useState<boolean>(false);
	var [loadingApple, setLoadingApple] = useState<boolean>(false);
	var authFrameUrl = API.getAuthFrameUrl();

	var isIOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
	var isAndroid = typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent);

	var onDownloadGooglePass = () => {
		if (!token || loadingGoogle) return;
		setWalletError(null);
		setLoadingGoogle(true);
		API.getGooglePass(token.access).then(res => {
			setLoadingGoogle(false);
			if (res.error || !res.data?.saveUrl) {
				setWalletError(res.message || 'Error al generar el pase de Google Wallet');
				return;
			}
			window.location.href = res.data.saveUrl;
		}).catch(e => {
			console.error(e);
			setLoadingGoogle(false);
			setWalletError('Error al descargar el pase de Google Wallet');
		});
	};

	var onDownloadApplePass = () => {
		if (!token || loadingApple) return;
		setWalletError(null);
		setLoadingApple(true);
		API.getApplePass(token.access).then(res => {
			setLoadingApple(false);
			if (res.error || !res.data?.buffer) {
				setWalletError(res.message || 'Error al descargar el pase');
				return;
			}
			const base64Buffer = res.data.buffer;
			const binaryString = window.atob(base64Buffer);
			const len = binaryString.length;
			const bytes = new Uint8Array(len);
			for (let i = 0; i < len; i++) {
				bytes[i] = binaryString.charCodeAt(i);
			}
			const blob = new Blob([bytes.buffer], { type: res.data.mimeType });
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'cocoan.pkpass');
			document.body.appendChild(link);
			link.click();
			link.parentNode?.removeChild(link);
		}).catch(e => {
			console.error(e);
			setLoadingApple(false);
			setWalletError('Error al descargar el pase de Apple Wallet');
		});
	};

	useEffect(() => {
		setTitle('Club Rewards | COCOAN', false);
	}, [setTitle]);

	useEffect(() => {
		const handleMessage = (event: MessageEvent) => {
			if (event.data?.type === 'cocoan-account-created') {
				window.history.replaceState(null, '', '/rewards/gracias');
			}
		};
		window.addEventListener('message', handleMessage);
		return () => window.removeEventListener('message', handleMessage);
	}, []);

	return (
		<main className='co rewards-screen'>

			<header className='rewards-hero'>
				<picture>
					<img src={`${CDN_URL}/static/rewards/BANNER_REWARDS.webp`} alt='COCOAN Club Rewards' className='hero-bg' />
				</picture>
				<div className='hero-overlay'>
					<span className='welcome-tag font-graphik-bold'>Welcome to the</span>
					<img src={`${CDN_URL}/static/rewards/BANNER_TEXT_REWARDS.webp`} alt='COCOAN Club Rewards' className='hero-text-img' />
				</div>
			</header>

			<section className='rewards-register-split' aria-labelledby='register-heading'>
				<div className='section-container split-grid-wrapper'>
					<div className='split-left-image'>
						<img
							src={`${CDN_URL}/static/rewards/REWARDS.webp`}
							alt='Productos COCOAN'
						/>
					</div>
					<div className='split-right-form'>
						{login && user ? (
							<>
								<h2 id='register-heading' className='register-title font-graphik-bold' style={{ marginBottom: 10 }}>
									¡Bienvenid{user.gender_id===1 ? 'o' : user.gender_id===2 ? 'a' : 'es'} <br /> {user.first_name || user.name}!
								</h2>
								<div style={{ display: 'flex', flexDirection: 'column', gap: 15, marginTop: 30 }}>
									<Button
										text='Ver mi perfil'
										color='yellow'
										onClick={() => { window.location.href = '/account'; }}
									/>
									<Button
										text='Seguir comprando'
										color='white'
										onClick={() => { window.location.href = '/shop'; }}
									/>
									<div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 10, width: '100%', flexDirection: 'column', alignItems: 'center' }}>
										{walletError && (
											<div style={{ color: '#e74c3c', fontSize: 13, textAlign: 'center', marginBottom: 10, width: '100%', padding: '0 20px' }}>
												{walletError}
											</div>
										)}
										<div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
											{(!isIOS || isAndroid) && (
													<img 
														src="/badges/add_to_google_wallet.svg" 
														alt="Agregar a Google Wallet"
														onClick={onDownloadGooglePass}
														style={{ height: 40, opacity: loadingGoogle ? 0.6 : 1, cursor: loadingGoogle ? 'wait' : 'pointer', objectFit: 'contain' }}
													/>
											)}
											{(!isAndroid || isIOS) && (
													<img 
														src="/badges/add_to_apple_wallet.svg" 
														alt="Agregar a Apple Wallet"
														onClick={onDownloadApplePass}
														style={{ height: 40, opacity: loadingApple ? 0.6 : 1, cursor: loadingApple ? 'wait' : 'pointer', objectFit: 'contain' }}
													/>
											)}
										</div>
									</div>
								</div>
								<div style={{ marginTop: 'auto', marginBottom: -50, paddingTop: 40, width: '100%', textAlign: 'center' }}>
									<img 
										src={`${CDN_URL}/static/rewards/COCOANITO.webp`} 
										alt='Cocoanito' 
										style={{ width: '100%', maxWidth: '850px', height: 'auto', maxHeight: '400px', objectFit: 'contain', display: 'block', margin: '0 auto' }} 
									/>
								</div>
							</>
						) : (
							<>
								<h2 id='register-heading' className='register-title font-graphik-bold'>¡Bienvenido!</h2>
								<h3 className='register-subtitle font-graphik-bold'>Regístrate aquí</h3>
								{authFrameUrl ? (
									<div className='register-iframe-container'>
										<iframe
											src={authFrameUrl}
											title='Crear cuenta COCOAN'
											className='register-iframe'
											frameBorder='0'
										/>
									</div>
								) : (
									<Button
										text='Crear cuenta'
										color='black'
										style={{ marginTop: 20 }}
										onClick={() => { window.location.href = API.getAuthUrl() || '/auth'; }}
									/>
								)}
							</>
						)}
					</div>
				</div>
			</section>

			<section className='rewards-intro-cream' aria-labelledby='what-heading'>
				<div className='section-container'>
					<div className='intro-cream-inner'>
						<h2 id='what-heading' className='intro-title font-graphik-bold'>
							¿QUÉ ES COCOAN <br /> CLUB REWARDS?
						</h2>
						<p className='intro-description font-graphik-regular'>
							Cocoan Club Rewards es nuestra forma de reconocer a quienes forman parte de nuestra comunidad más cercana. Al registrarte, cada visita y cada compra que hagas te acerca a beneficios, productos exclusivos y experiencias que reservamos únicamente para nuestros miembros más leales. Para ser parte del Club, sólo tienes que registrarte.
						</p>
					</div>
				</div>
			</section>

			<section className='rewards-benefits' aria-labelledby='benefits-heading'>
				<div className='benefits-inner section-container'>
					<h2 id='benefits-heading' className='section-title font-graphik-bold'>Descubre los beneficios</h2>
					<ul className='benefits-grid' role='list'>
						{BENEFITS.map((b, i) => (
							<li className='benefit-card' key={i}>
								<span className='benefit-icon' aria-hidden='true'>{b.icon}</span>
								<h3 className='benefit-title font-graphik'>{b.title}</h3>
								<p className='benefit-desc font-graphik-light'>{b.desc}</p>
							</li>
						))}
					</ul>
				</div>
			</section>

			<section className='rewards-levels-section' aria-labelledby='levels-heading'>
				<div className='section-container'>
				<h2 id='levels-heading' className='levels-section-title font-graphik-bold'>
						Logra tu nivel <span className="font-homemade-apple">cocoin chocolover</span>
					</h2>
					<div className='levels-cards-grid'>
						{LEVEL_CARDS.map((level, i) => (
							<article className='level-card-new' key={i}>
								<figure className='card-image-wrapper'>
									<img src={level.img} alt={`Nivel ${i + 1}`} />
								</figure>
								<div className='card-body'>
									<div className='card-header-info'>
										<h3 className='level-name'>{level.name}</h3>
										<div className='beans-icons'>
											{Array.from({ length: level.beans }).map((_, idx) => (
												<span key={idx} className='bean-icon red-diamond'>🍫</span>
											))}
										</div>
									</div>
									<p className='level-desc font-graphik-regular'>{level.desc}</p>
									<ul className='perks-list'>
										{level.perks.map((perk, idx) => (
											<li key={idx}>{perk}</li>
										))}
									</ul>
									<div className='level-badge-container'>
										<span className='level-badge-text font-graphik-bold'>{level.badge_text}</span>
										{level.sub_text && <span className='level-badge-sub font-graphik-regular'>{level.sub_text}</span>}
									</div>
								</div>
							</article>
						))}
					</div>
				</div>
			</section>

			<section className='split-info-section'>
				<div className='split-grid'>
					<article className='info-column dark-column'>
						<h3 className='font-graphik-bold'>
							Vigencia de <br /> Cocoins
						</h3>
						<p className='info-text font-graphik-regular'>
							La vigencia de tus Cocoins es de 6 meses posteriores a la realización de la compra. Todos los beneficios, incluyendo las Cocoins, son intransferibles y no se podrán utilizar después del periodo de 6 meses.
						</p>
					</article>
					<article className='info-column image-column'>
						<img src={`${CDN_URL}/static/rewards/CHOCOLOVERS.webp`} alt='Mousse 72% COCOAN' className='split-img' />
					</article>
				</div>
			</section>
		</main>
	);
};

export default Rewards;
